import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import View from "./View.js";

function Container({
  dismiss,
  getDevices,
  switchDevice,
  getVolume,
  setVolume,
  micTestStart,
  micTestStop,
  speakerTestStart,
  speakerTestStop,
}) {
  const userId = useSelector(state => state.userinfo.id);
  const [micList, setMicList] = useState([]);
  const [speakerList, setSpeakerList] = useState([]);
  const [currentMic, setCurrentMic] = useState([]);
  const [currentSpeaker, setCurrentSpeaker] = useState([]);
  const [isMicListOpen, setIsMicListOpen] = useState(false);
  const [isSpeakerListOpen, setIsSpeakerListOpen] = useState(false);
  const [firstMicVolume, setFirstMicVolume] = useState(0);
  const [firstSpeakerVolume, setFirstSpeakerVolume] = useState(0);
  const [micVolume, setMicVolume] = useState(0);
  const [speakerVolume, setSpeakerVolume] = useState(0);
  const [micTestLevel, setMicTestLevel] = useState(0);
  const [isTestMode, setIsTestMode] = useState(null);
  const [micTestInfo, setMicTestInfo] = useState(null);
  const [speakerTestInfo, setSpeakerTestInfo] = useState(null);

  useEffect(() => {
    _getDevices();
  }, []);

  const _getDevices = async () => {
    const {micList, speakerList, currentMic, currentSpeaker} =
      await getDevices();
    setMicList(micList);
    setSpeakerList(speakerList);
    setCurrentMic(currentMic);
    setCurrentSpeaker(currentSpeaker);
  };

  const onClickList = type => {
    if (type === "speaker") {
      setIsSpeakerListOpen(!isSpeakerListOpen);
      setIsMicListOpen(false);
    } else {
      setIsMicListOpen(!isMicListOpen);
      setIsSpeakerListOpen(false);
    }
  };

  const onClickDevice = (type, deviceId) => {
    switchDevice(type, deviceId);
    setIsSpeakerListOpen(false);
    setIsMicListOpen(false);
    if (type === "mic") {
      const device = micList.find(mic => mic.deviceId === deviceId);
      setCurrentMic(device);
    } else {
      const device = speakerList.find(speaker => speaker.deviceId === deviceId);
      setCurrentSpeaker(device);
    }
  };

  useEffect(() => {
    const [speakerVolume, micVolume] = getVolume();
    setFirstSpeakerVolume(speakerVolume);
    setFirstMicVolume(micVolume);
  }, []);

  useEffect(() => {
    _getVolume();
  }, [speakerVolume, micVolume]);

  const _getVolume = async () => {
    const [speakerVolume, micVolume] = await getVolume();
    setMicVolume(micVolume);
    setSpeakerVolume(speakerVolume);
    return [speakerVolume, micVolume];
  };

  const onChangeRange = (type, value) => {
    setVolume(type, value);
    _getVolume();
  };

  const onClickTest = async type => {
    if (type === "mic") {
      if (isTestMode === "mic") {
        micTestStop(micTestInfo);
        setMicTestLevel(0);
        setIsTestMode(null);
      } else {
        const micTestInfo = await micTestStart(userId, setMicTestLevel);
        setMicTestInfo(micTestInfo);
        setIsTestMode("mic");
      }
    } else {
      if (isTestMode === "speaker") {
        setIsTestMode(null);
        speakerTestStop(speakerTestInfo);
      } else {
        const track = await speakerTestStart();
        setSpeakerTestInfo(track);
        setIsTestMode("speaker");
      }
    }
  };

  const onClickClose = () => {
    if (isTestMode === "mic") {
      micTestStop(micTestInfo);
      setMicTestLevel(0);
    } else if (isTestMode === "speaker") {
      speakerTestStop(speakerTestInfo);
    }
    setIsTestMode(null);

    firstMicVolume && onChangeRange("mic", firstMicVolume);
    firstSpeakerVolume && onChangeRange("speaker", firstSpeakerVolume);
    dismiss();
  };

  return (
    <View
      dismiss={dismiss}
      speakerVolume={speakerVolume}
      speakerList={speakerList}
      isSpeakerListOpen={isSpeakerListOpen}
      currentSpeaker={currentSpeaker}
      isTestMode={isTestMode}
      micVolume={micVolume}
      micList={micList}
      currentMic={currentMic}
      isMicListOpen={isMicListOpen}
      micTestLevel={micTestLevel}
      onClickClose={onClickClose}
      onClickList={onClickList}
      onChangeRange={onChangeRange}
      onClickTest={onClickTest}
      onClickDevice={onClickDevice}
    />
  );
}

export default Container;
